var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconOutbound = function SvgIconOutbound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1926 82.4734H21.4503V40.8926H39.4163H43.8666H52.7763H57.2266H75.1926V54.8755H79.6429V38.6756V38.6664V38.6572C79.6429 38.648 79.6429 38.6388 79.6429 38.6204C79.6337 38.1788 79.5055 37.7833 79.2857 37.4429C79.2766 37.4337 79.2766 37.4245 79.2674 37.4153V37.4061C79.2674 37.4061 79.2674 37.3969 79.2583 37.3969L70.3668 23.9935C69.9548 23.3772 69.2588 23 68.508 23H28.1257C27.384 23 26.6881 23.3772 26.276 23.9935L17.3846 37.4061C17.3846 37.4061 17.3846 37.4061 17.3846 37.4153V37.4245C17.3754 37.4337 17.3754 37.4429 17.3663 37.4613C17.119 37.8109 17.0092 38.2156 17 38.6296C17 38.6388 17 38.648 17 38.6664V38.6756V38.6848V87.0822H17.2564H21.4594H75.2017H79.533H79.6612V69.6036H75.2109V82.4734H75.1926ZM50.6061 27.4709H67.3267L73.2604 36.4218H50.6061V27.4709ZM29.3253 27.4709H46.1466V36.4218H23.3916L29.3253 27.4709Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4571 33.9656L82.9304 47.4977L86.2818 50.6347L93.1679 43.1925V50.0275C93.1679 55.3723 88.8366 59.7236 83.5164 59.7236H48.3262V64.3232H83.5256C91.3731 64.3232 97.7555 57.9113 97.7555 50.0275V43.1833L104.642 50.6255L107.993 47.4885L95.4571 33.9656Z",
    fill: "#222222"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOutbound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-outbound.f9fb2daa.svg";
export { ForwardRef as ReactComponent };